import React from 'react'
import Box from '@mui/material/Box';
import { useState } from 'react'
import { FinancialProtectionList } from './FinancialProtectionList';
import { CreateFinancialProtection } from './CreateFinancialProtection';
import { FinancialProtectionModel } from 'model/screensModels/FinancialProtectionModel';
import { PaginatorModel } from 'model/utilModels/PaginatorModel';
import { FinancialProtectionService } from 'services/menu/financialProtection/FinancialProtectionService';
import { msgTypes } from 'constants/msgTypes';
import { DataNotFound } from 'screens/sharedScreens/dataNotFound/DataNotFound';

export const FinancialProtection = () => {
    const [updateValue, setUpdateValue] = React.useState(new FinancialProtectionModel());
    const [flag, setFlag] = useState(false)
    const [recentGuidelines, setRecentGuidelines] = useState(new FinancialProtectionModel());
  const [isEditMode, setIsEditMode] = useState(false);

    React.useEffect(() => {
        loadRecentGuideline();
    }, [])

    //Prepare request body 
    const prepareRequest = () => {
        const requestBody = new PaginatorModel();
        requestBody.pageNumber = 0;
        requestBody.pageSize = 1;
        return requestBody;
    }

    //Get recent guidelines list
    const loadRecentGuideline = async () => {
        const requestBody = prepareRequest();
        const res = await FinancialProtectionService.getFinancialList(requestBody);
        if (res.statusMsg === msgTypes.SUCCESS.msg) {
            if (res?.data !== '') {
                setRecentGuidelines(res?.data?.tbody[0]);
            } else {
                setRecentGuidelines(new FinancialProtectionModel());
            }
        }
    }

    const addFinancial = () => {
        setUpdateValue(new FinancialProtectionModel())
        setIsEditMode(false); // Reset edit mode
        setFlag(true);
    }

    //to get update record value
    const getUpdateRecordValue = (data: FinancialProtectionModel) => {
        setIsEditMode(true);
        setUpdateValue(data);
    }

    const RecentGuidelines = () => {
        return (
            <>
                <h5 className='pb-3 recent-heading'>Recently added Guidelines </h5>
                {recentGuidelines.financialProtectionId !== '' ? (
                    <div className='row recent-row'>
                        <div className='col-lg-3 '>
                            <h5>Heading : </h5>
                        </div>
                        <div className='col-lg-9'>
                            {recentGuidelines.financialProtectionHeading}
                        </div>
                        <div className='col-lg-3 '>
                            <h5>Message : </h5>
                        </div>
                        <div className='col-lg-9'>
                            {recentGuidelines.financialProtectionMessage}
                        </div>
                    </div>
                ) : (
                    <>
                        <DataNotFound message="There is no Guidelines" />
                    </>
                )}
            </>
        )
    }

    return (
        <>
            <Box sx={{ width: '100%' }} className="container container-h-full">
                <Box>
              
                                  
      <div className="content-subheader">
            {!flag ? (
              <h2 className="mr-3 font-weight-bolder">Financial Protection Guidelines List</h2>
            ) : (
              <h2 className=" font-weight-bolder mr-3">{isEditMode ? 'Edit Financial Protection Guidelines' : 'Add Financial Protection Guidelines'}</h2>
            )}
            {!flag && <button className="btn primary" onClick={addFinancial}>  Add Financial Protection Guidelines</button>}
          </div>
                </Box>

                <>

                    {!flag ?
                        <div className='sub-content-sec recently-blog shadow-none'>
                            <FinancialProtectionList setFlag={setFlag} updateRecord={getUpdateRecordValue} loadRecentGuideline={loadRecentGuideline} />
                        </div>
                        :

                        <div className='row'>
                            <div className='col-lg-4 work'>
                                <div className='sub-content-sec recently-blog'>
                                    <RecentGuidelines />
                                </div>
                            </div>
                            <div className='col-lg-8'>
                                <div className='sub-content-sec recently-blog'>
                                    <CreateFinancialProtection setFlag={setFlag} updateRecord={updateValue} loadRecentGuideline={loadRecentGuideline}></CreateFinancialProtection>
                                </div>
                            </div>
                        </div>
                    }

                </>

            </Box>
        </>
    )
}
